import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { switchManufacturer } from 'src/store/actions/authActions';
import { SyncUser } from 'src/store/models/Auth';
import { getAddress } from 'src/utils/addressUtils';

import Button from '../Button/Button';
import Table from '../Table/Table';
import { TableHeader } from '../Table/Table.interface';
import classes from './ManufacturersTable.module.scss';

const ManufacturersTable: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const user = useAppSelector((state) => state.auth.user);

  const headers: TableHeader<SyncUser>[] = [
    {
      accessor: 'company',
      label: t('common:manufacturer'),
      fontWeight: 700,
      component: (u) => u?.company?.title,
    },
    {
      accessor: 'company',
      label: t('common:address'),
      component: (u) => getAddress(u?.company),
    },
    {
      accessor: 'company',
      label: t('common:email'),
      component: (u) => u?.company?.eMail,
    },
    {
      accessor: 'company',
      label: t('common:phone'),
      component: (u) => u?.company?.phone,
    },
  ];

  const data = useMemo(
    () => [
      ...(user?.allUsers?.filter(
        (u) => u?.manufacturer?.id === user?.manufacturer?.id
      ) || []),
      ...(user?.allUsers
        ?.filter((u) => u?.manufacturer?.id !== user?.manufacturer?.id)
        .sort((a, b) =>
          a?.company?.title.localeCompare(b?.company?.title, undefined, {
            ignorePunctuation: true,
          })
        ) || []),
    ],
    [user?.manufacturer?.id, user?.allUsers]
  );

  return (
    <Table
      className={classes.Table}
      headers={headers}
      data={data}
      disableHover
      endNode={(other) => (
        <div className={classes.EndNode}>
          <Button
            disabled={other?.manufacturer?.id === user?.manufacturer?.id}
            size="small"
            onClick={() => {
              dispatch(switchManufacturer({ manId: other?.manufacturer?.id }));
            }}
          >
            {t('settings:switch_account')}
          </Button>
        </div>
      )}
    />
  );
};

export default ManufacturersTable;
